import { PropsWithChildren, useState } from 'react';
import { GlobalDialogType } from './global-dialog.type';
import { GlobalDialogsContext } from './context';

type Props = PropsWithChildren;

export const GlobalDialogsProvider = ({ children }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [dialog, setDialog] = useState<GlobalDialogType | null>(null);

  const openDialog = (dialog: GlobalDialogType): void => {
    setDialog(dialog);
    setIsOpen(true);
  };

  const closeDialog = (): void => {
    setIsOpen(false);
    setTimeout(() => setDialog(null), 300);
  };

  return (
    <GlobalDialogsContext.Provider
      value={{
        dialog,
        isOpen,
        openDialog,
        closeDialog
      }}
    >
      {children}
    </GlobalDialogsContext.Provider>
  );
};
